module.exports = __webpack_public_path__ + "img/42.3.TP.9f98b39a.png";